import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import ReferralLanding from "./pages/ReferralLanding";

const Routes = () => {
    return (
        <Router>
            <Switch>
                <Route path="/mref/:referralCode">
                    <ReferralLanding />
                </Route>
                <Route path="/reff/:referralCode">
                    <ReferralLanding />
                </Route>
            </Switch>
        </Router>
    );
};

export default Routes;